import { render, staticRenderFns } from "./dashboard.pug?vue&type=template&id=7047defb&scoped=true&lang=pug&"
import script from "./dashboard.ts?vue&type=script&lang=ts&"
export * from "./dashboard.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=7047defb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047defb",
  null
  
)

export default component.exports